
import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { JqueryInitService } from 'src/app/Core/_services/jquery/jquery-init.service';
import { ImageLightboxComponent } from 'src/app/Shared/components/image-lightbox/image-lightbox.component';

@Component({
    selector: 'app-horse-images-gallary',
        standalone: true,
imports: [],
    templateUrl: './horse-images-gallary.component.html',
    styleUrl: './horse-images-gallary.component.scss'
})
export class HorseImagesGallaryComponent {
  @Input() images: any = [];
  activeImageIndex: number = 0;

  constructor(
    private dialog: MatDialog,
    private jqueryInitService: JqueryInitService
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.jqueryInitService.initAuctionDetailsNavSlider();
    }, 100);
  }

  setActiveImage(index: number): void {
    this.activeImageIndex = index;
    // Update the active image without opening the lightbox
    this.images.activeImage = this.images.thumbnails[index];
    this.openLightbox(index);
  }
  openActiveImg(img: any) {
    if (img != '/assets/images/defualt-image.jpg') {
      // Open lightbox at current active index
      this.openLightbox(this.activeImageIndex);
    }
  }
  openLightbox(index: number): void {
    // console.log(this.thumbnails);
    this.dialog.open(ImageLightboxComponent, {
      data: {
        src: this.images?.thumbnails[index]?.src,
        images: this.images?.thumbnails,
        currentIndex: index,
      },

      panelClass: ['custom-dialog-container', 'buyer-theme'],
      maxWidth: '95vw',
      maxHeight: '95vh',
    });
  }
}
